import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import {
    Fade,
    Grid,
    makeStyles,
    Modal,
    Paper,
    TableCell,
    TableFooter,
    TableRow,
    Typography,
    Backdrop,
    Hidden,
    Button,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, reviewStyle } from '../../../UIComponent/CommonStyle';
import { FormattedMessage, useIntl } from 'react-intl';
import { setColumns } from './TableSetting';
import { submitRequest } from '../../api/api';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import moment from 'moment';
import ConfirmBox from '../../../UIComponent/ConfirmBox';
import WithDrawConfirm from '../../../LeaveApplication/component/Form/WithDrawConfirm';
import customAxios from "../../../API/customAxios";
import { isDesktop, isMobile, isTablet } from "react-device-detect";
import { checkIsTabletDevice, setLocalStorageSettings } from '../../../Function/globalFunction';
import ConfirmationBox from '../../../LeaveApplication/component/Form/ConfirmationBox';
import CancelAlertBox from './CancelAlertBox';

const useStyles = makeStyles((theme) => ({
    ...reviewStyle(theme),
    footerCell: {
        borderBottom: 'none',
        color: '#232F3F',
        fontSize: 14,
        fontWeight: 'bolder',
        textAlign: 'end',
    },
    submitButtonDiv: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    spaceBetween: {
        display: 'flex',
        justifyContent:'space-between',
        alignItems: 'center',
    },
}));

let action = ''; 

function getTime(dateTime){
    return moment({h: dateTime.hours(), m: dateTime.minutes()});
}

export default function CompLeaveForm({ mode, application, isApprover, approveId, approveMode, actionPage, tabIndex, backToTable }) {
    const intl = useIntl();
    const history = useHistory();
    const classes = useStyles();
    const location = useLocation();
    const isTabletDevice = checkIsTabletDevice() || isTablet;
    const isSubmitMode = mode === window.global.submitMode;
    const isShiftDuty = localStorage.getItem('staff_duty') === window.global.shiftDuty;
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(isSubmitMode ? (isDesktop ? 5 : 1) : (isDesktop ? 5 : 2));
    const [totalHours, setTotalHours] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [errorMessages, setErrorMessages] = React.useState([]);
    const [submitButton, setSubmitButton] = React.useState(false);
    const [addButton, setAddButton] = React.useState(false);
    const [approveButton, setApproveButton] = React.useState(false);
    const [disabled, setDisabled] = React.useState(false);
    const [formTitle, setFormTitle] = React.useState('');
    const [approveOpen, setApproveOpen] = React.useState(false);
    const [withDrawOpen, setWithDrawOpen] = React.useState(false);
    const [alertCancelOpen, setAlertCancelOpen] = React.useState(false);
    const [withDrawnButton, setWithDrawnButton] = React.useState(false);
    const [cancelButton, setCancelButton] = React.useState(false);
    const [resubmitButton, setResubmitButton] = React.useState(false);
    const [resubmitOpen, setResubmitOpen] = React.useState(false);
    const [unformattedHoliday, setUnformattedHoliday] = React.useState([]);
    const [recentApprovedLeaveDates, setRecentApprovedLeaveDates] = React.useState([]);
    const [appliedCompLeaveReqItems, setAppliedCompLeaveReqItems] = React.useState([]);
    const [showRemoveFile, setShowRemoveFile] = React.useState(false);
    const [compLeaveRecord, setCompLeaveRecord] = React.useState([]);
    const [hasCompLeaveRecord, setHasCompLeaveRecord] = React.useState(false);
    const [confirmationDialog, setConfirmationDialog] = React.useState(
        {
            open: false,
            title: '',
            msg: '',
            uploadingMessage: false,
            error: false
        }
    );
    const [rows, setRows] = React.useState([
        {
            from: '',
            to: '',
            hours: 0,
            description: '',
            attachment: [],
            includeMealHour: false,
        },
    ]);

    React.useEffect(() => {
        let appliedCompLeaveReqItems = [];
        let rows = [];
        const isSubmitted = String(application?.[0]?.status || application?.status) === window.global.submitted;
        const isPending = String(application?.[0]?.status || application?.status) === window.global.pending;
        const isApproved = String(application?.[0]?.status || application?.status) === window.global.approved;
        const isRejected = String(application?.[0]?.status || application?.status) === window.global.rejected;
        const isWithdrawn = String(application?.[0]?.status || application?.status) === window.global.withdrawn;
        const isCancelled = String(application?.[0]?.status || application?.status) === window.global.cancelled;
        const isEmployeeRecordPage = actionPage === 'Employee Record';

        switch (mode) {
            case window.global.submitMode:
                const resubmitData = location.state?.applicationData;
                if (resubmitData) {
                    setRows(resubmitData.rows || []);
                    setTotalHours(resubmitData.totalHours || 0);
                } else {
                    setRows([{ 
                        from: '', 
                        to: '', 
                        hours: 0, 
                        description: '', 
                        attachment: [],
                        includeMealHour: false 
                    }]);
                    setTotalHours(0);
                }
    
                setFormTitle(intl.formatMessage({id: 'navigation.application'}) + ' - ' + intl.formatMessage({id: 'comp_leave.comp_leave_request'}));
                setSubmitButton(true);
                setAddButton(true);
                setDisabled(false);
                setApproveButton(false);
                setWithDrawnButton(false);
                setCancelButton(false);
                setShowRemoveFile(true);
                break;
            case window.global.editMode:
                setFormTitle(intl.formatMessage({id: 'comp_leave.comp_leave_request'}) + ' (' + intl.formatMessage({id: 'status.' + application[0].status}) + ')');
                setSubmitButton(false);
                setAddButton(false);
                setDisabled(true);
                setApproveButton(false);
                setShowRemoveFile(false);
                setWithDrawnButton(isSubmitted && !isEmployeeRecordPage);
                setResubmitButton(!isEmployeeRecordPage && (isRejected || isWithdrawn || isCancelled));

                const checkHrAdminRoleEdit = (isHrAdmin) => {
                    setCancelButton(isHrAdmin && isEmployeeRecordPage && (isSubmitted || isPending || isApproved));
                }

                const isHrAdminRoleEdit = JSON.parse(localStorage.getItem('isHrAdminRole'));
				if (isHrAdminRoleEdit === null) {
                    customAxios.get('/get_permission')
                    .then(res => {
                        const isHrAdmin = res.data.hr_admin === true;
                        localStorage.setItem('isHrAdminRole', isHrAdmin);
                        checkHrAdminRoleEdit(isHrAdmin);
                    })
				} else {
                    checkHrAdminRoleEdit(isHrAdminRoleEdit);
                }

                appliedCompLeaveReqItems = application[0].comp_leave_req_items;
                rows = formatAppliedCompLeaveReqItems(appliedCompLeaveReqItems);
                setRows(rows);
                break;
            case window.global.approveMode:
                setFormTitle(
                    application.employee.employee_name +
                        ' (' +
                        intl.formatMessage({
                            id: 'status.' + application.status,
                        }) +
                        ')'
                );
                setSubmitButton(false);
                setAddButton(false);
                setDisabled(true);
                setWithDrawnButton(false);
                setCancelButton(false);
                setShowRemoveFile(false);
                if (
                    String(application.status) === window.global.pending ||
                    String(application.status) === window.global.submitted
                ) {
                    setApproveButton(true);
                } else {
                    setApproveButton(false);
                }

                appliedCompLeaveReqItems = application.comp_leave_req_items;
                rows = formatAppliedCompLeaveReqItems(appliedCompLeaveReqItems);
                setRows(rows);
                break;
            case window.global.viewMode:
                const checkHrAdminRoleView = (isHrAdmin) => {
                    setCancelButton(isHrAdmin && (isSubmitted || isPending || isApproved));
                }

                const isHrAdminRoleView = JSON.parse(localStorage.getItem('isHrAdminRole'));
				if (isHrAdminRoleView === null) {
                    customAxios.get('/get_permission')
                    .then(res => {
                        const isHrAdmin = res.data.hr_admin === true;
                        localStorage.setItem('isHrAdminRole', isHrAdmin);
                        checkHrAdminRoleView(isHrAdmin);
                    })
				} else {
                    checkHrAdminRoleView(isHrAdminRoleView);
                }

                setFormTitle(
                    application.employee.employee_name +
                        ' (' +
                        intl.formatMessage({
                            id: 'status.' + application.status,
                        }) +
                        ')'
                );
                setSubmitButton(false);
                setAddButton(false);
                setDisabled(true);
                setWithDrawnButton(false);
                setShowRemoveFile(false);
                setApproveButton(
                    isApprover &&
                    (   
                        String(application.status) === window.global.pending ||
                        String(application.status) === window.global.submitted
                    )
                );

                appliedCompLeaveReqItems = application.comp_leave_req_items;
                rows = formatAppliedCompLeaveReqItems(appliedCompLeaveReqItems);
                setRows(rows);
                break;
        }
    }, [mode]);

    React.useEffect(() => {
        const sum = rows.reduce((total, row) => {
            const hoursValue = calculateHours(row.from, row.to, row.includeMealHour);
            return total + (hoursValue > 0 ? hoursValue : 0);
        }, 0);
        setTotalHours(sum);
    }, [rows]);

    React.useEffect(() => {
        if (isSubmitMode) {
            if (!isShiftDuty) {
                customAxios.get(`/get_holiday`).then(res => {
                    let data = [];
                    let unformattedData = [];
                    let getHoliday = res.data;
                    for (let i = 0; i < getHoliday.length; i++) {
                        let holidayYear = moment(new Date(getHoliday[i].date)).format('YYYY');
                        let holidayMonth = moment(new Date(getHoliday[i].date)).format('M');
                        let holidayDay = moment(new Date(getHoliday[i].date)).format('D');
                        unformattedData.push(getHoliday[i].date);
                        data.push({
                            year: Number(holidayYear),
                            month: Number(holidayMonth),
                            day: Number(holidayDay),
                            className: 'highlight'
                        });
                    }
                    setUnformattedHoliday(unformattedData);
                })

                customAxios.get('/get_recent_approved_leave_dates').then(res => {
                    const approvedLeaveDates = res.data;
                    if (approvedLeaveDates) {
                        setRecentApprovedLeaveDates(approvedLeaveDates);
                    }
                })
            }

            customAxios.get('/get_applied_comp_leave_req_items').then((res) => {
                const compLeaveReqItems = res.data;
                if (compLeaveReqItems) {
                    setAppliedCompLeaveReqItems(compLeaveReqItems);
                }
            });
        }
    }, [])

    const formatAppliedCompLeaveReqItems = (appliedCompLeaveReqItems) => {
        return appliedCompLeaveReqItems.map((item) => ({
            from: item.from,
            to: item.to,
            hours: item.hours,
            description: item.description || '',
            attachment: item.attachment,
            includeMealHour: Boolean(item.include_meal_hour) || false,
        }));
    }

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const handleAddRow = () => {
        const newRow = {
            from: '',
            to: '',
            hours: 0,
            description: '',
            attachment: [],
            includeMealHour: false,
        };
        setRows([...rows, newRow]);

        const newPage = Math.ceil((rows.length + 1) / rowsPerPage) - 1;
        setPage(newPage);
    };

    const handleRemoveRow = (index) => {
        setRows((prevRows) => prevRows.filter((row, i) => i !== index));

        if (page > 0 && (rows.length - 1) % rowsPerPage === 0) {
            setPage(page - 1);
        }
    };

    const handleInputChange = (index, field, value) => {
        setRows(prevRows => prevRows.map((row, i) => {
            if (i !== index) return row;
            
            const updatedRow = { ...row, [field]: value };
            if (field === 'from' || field === 'to') {
                const rawHours = calculateHours(updatedRow.from, updatedRow.to, false);

                updatedRow.includeMealHour = rawHours >= 9;
                updatedRow.hours = calculateHours(updatedRow.from, updatedRow.to, updatedRow.includeMealHour);
            }
            return updatedRow;
        }));
    };

    const handleCheckboxChange = (index, checked) => {
        setRows(prevRows => {
            const updatedRows = prevRows.map((row, i) => {
                if (i === index) {
                    const newHours = calculateHours(row.from, row.to, checked);
                    return { ...row, includeMealHour: checked, hours: newHours };
                }
                return row;
            });
    
            const newTotalHours = updatedRows.reduce((sum, row) => sum + row.hours, 0);
            setTotalHours(newTotalHours);
    
            return updatedRows;
        });
    };

    const handleConfirmOpen = async (act) => {
        action = act;

        if (
            act === 'cancel' &&
            (
                // Employee Record page
                (actionPage === 'Employee Record' && mode === window.global.editMode) ||
                // My Team page
                mode === window.global.viewMode
            )
        ) {
            try {
                const applicationId = application?.[0]?.id || application?.id;
                const res = await customAxios.get(`/get_comp_leave_record/${applicationId}`);
                const remainingBalance = res.data;
                setHasCompLeaveRecord(res.data.length > 0);

                if (res.data.length > 0) {
                    setCompLeaveRecord(res.data);
                    setAlertCancelOpen(true);
                } else {
                    setWithDrawOpen(true);
                }
            } catch (error) {
                console.error('Error fetching comp leave record:', error);
            }
        } else {
            if (act === 'approve' || act === 'reject') {
                setApproveOpen(true);
            } else if (act === 'withdraw' || act === 'cancel') {
                setWithDrawOpen(true);
            }
        }
    };

    const handleConfirmClose = (event, reason) => {
        if (action === 'cancel' && 
            hasCompLeaveRecord && 
            (
                // Employee Record page
                (actionPage === 'Employee Record' && mode === window.global.editMode) ||
                // My Team page
                mode === window.global.viewMode
            )
        ) {
            if (reason !== 'backdropClick') {
                setAlertCancelOpen(false);
            }
        } else if (action === 'approve' || action === 'reject') {
            setApproveOpen(false);
        } else if (action === 'withdraw' || action === 'cancel') {
            setWithDrawOpen(false);
        }
    };

    const handleResubmit = () => {
        setLocalStorageSettings({
            'selectedIndex': 2,
            'isMyRequestOpen': 'false',
            'isApplicationOpen': 'true',
            'isLeaveApprovalOpen': 'false',
            'isHRAdminOpen': 'false'
        });

        const applicationData = {
            rows: rows.map(row => ({
                ...row,
                from: moment(row.from, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm'),
                to: moment(row.to, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm'),
                attachment: row.attachment.map(file => ({
                    path: file.path,
                    filename: file.filename,
                    file_id: file.file_id,
                    extension: file.filename.split('.').pop(),
                    s3_url: file.s3_url,
                })),
                includeMealHour: row.includeMealHour || false,
            })),
            applicationId: application?.[0]?.id || application?.id,
            totalHours: totalHours,
        };

        history.push({
            pathname: '/comp_leave_request',
            state: { applicationData }
        });
    };

    const data = rows.map((row, index) => [
        row.from,
        row.to,
        row.hours,
        row.description,
        index,
    ]);

    const calculateHours = (fromValue, toValue, includeMealHour) => {
        if (!fromValue || !toValue) return 0;
        
        const from = moment(fromValue, 'YYYY-MM-DD HH:mm');
        const to = moment(toValue, 'YYYY-MM-DD HH:mm');
        let hours = Math.round(((to - from) / 1000 / 60 / 60) * 100) / 100;
        
        if (includeMealHour && hours >= 9) {
            const deductionHours = Math.floor(hours / 9);
            hours -= deductionHours;
        } else if (includeMealHour && hours >= 1.5) {
            hours -= 1;
        }
        
        return Math.max(hours, 0);
    };

    const calculateTotalHours = (updatedRows) => {
        let sum = 0;
        updatedRows.forEach((row) => {
            sum += calculateHours(row.from, row.to, row.includeMealHour) || 0;
        });
        setTotalHours(sum);
    };

    const validateFields = (rows) => {
        const missingField = intl.formatMessage({
            id: 'new_application.required_message',
        });
        const laterStartTime = intl.formatMessage({
            id: 'error.later_start_time',
        });
        const earlierEndTime = intl.formatMessage({
            id: 'error.earlier_end_time',
        });
        const sameStartEndTime = intl.formatMessage({
            id: 'error.same_start_end_time',
        });
        const overlappingTime = intl.formatMessage({
            id: 'error.overlapping_time',
        });
        const invalidMinutes = intl.formatMessage({
            id: 'error.allow_only_00_or_30_minutes_input',
        });
        const maxDateToday = intl.formatMessage({
            id: 'error.cannot_exceed_today',
        });

        const today = moment().startOf('day');
    
        const errorMessages = rows.map((row, rowIndex) => {
            let errors = {};

            // Check if 'from' field is missing
            if (!row.from) {
                errors.from = missingField;
            } else {
                const fromDate = moment(row.from, 'YYYY-MM-DD');
                // Check if 'from' date exceeds today
                if (fromDate.isAfter(today)) {
                    errors.from = maxDateToday;
                }
            }

            // Check if 'to' field is missing
            if (!row.to) {
                errors.to = missingField;
            } else {
                const toDate = moment(row.to, 'YYYY-MM-DD');
                // Check if 'to' date exceeds today
                if (toDate.isAfter(today)) {
                    errors.to = maxDateToday;
                }
                // Check if 'to' date is before 'from' date
                if (row.from && toDate.isBefore(moment(row.from, 'YYYY-MM-DD'))) {
                    errors.to = earlierEndTime;
                }
            }

            // Check if 'justification' field is missing or contains only whitespace
            if (!row.description || !row.description.trim()) {
                errors.description = missingField;
            }

            // Check if 'from' and 'to' times are the same
            if (row.from && row.to && row.to == row.from) {
                errors.from = sameStartEndTime;
                errors.to = sameStartEndTime;
            }

            // Check if 'from' time is after 'to' time
            if (row.from && row.to && row.from > row.to) {
                errors.to = earlierEndTime;
            }
            
            // Check if 'to' time is before 'from' time
            if (row.from && row.to && row.to < row.from) {
                errors.from = laterStartTime;
            }

            // Ensure the minutes input in 'from' or 'to' is either 00 or 30
            if (row.from && !['00', '30'].includes(moment(row.from).format('mm'))) {
                errors.from = invalidMinutes;
            }
            if (row.to && !['00', '30'].includes(moment(row.to).format('mm'))) {
                errors.to = invalidMinutes;
            }

            // Check for overlapping times with other rows
            rows.forEach((otherRow, otherIndex) => {
                if (rowIndex !== otherIndex) {
                    const rowStart = moment(row.from, 'YYYY-MM-DD HH:mm');
                    const rowEnd = moment(row.to, 'YYYY-MM-DD HH:mm');
                    const otherStart = moment(otherRow.from, 'YYYY-MM-DD HH:mm');
                    const otherEnd = moment(otherRow.to, 'YYYY-MM-DD HH:mm');

                    if (rowStart.isBefore(otherEnd) && rowEnd.isAfter(otherStart)) {
                        errors.from = overlappingTime;
                        errors.to = overlappingTime;
                    }
                }
            });

            return errors;
        });

        return errorMessages;
    };

    const handleSubmit = async () => {
        const updatedRows = rows.map((row) => ({
            ...row,
            description: row.description.trim(),
            hours: Math.max(calculateHours(row.from, row.to, row.includeMealHour), 0),
        }));
        calculateTotalHours(updatedRows);

        const errorMessages = validateFields(updatedRows);
        const hasError = errorMessages.some(
            (errors) => Object.keys(errors).length > 0
        );

        if (hasError) {
            setErrorMessages(errorMessages);
        } else {
            if (checkIsDuplicateWithAppliedCompLeaveReqItems(updatedRows)) {
                alert(intl.formatMessage({ id: 'error.duplicate_comp_leave_reqs' }));
                return;
            }

            if (!isShiftDuty && !validateCompLeaveTimes(updatedRows)) {
                alert(intl.formatMessage({ id: 'error.invalid_comp_leave_time' }));
                return;
            }

            if (updatedRows.length === 0) {
                alert(intl.formatMessage({ id: 'error.no_entry' }));
                return;
            }

            setErrorMessages([]);

            let concatJustification = [];
            rows.map((row, index) => {
                let maxLength = 90;
                let truncatedStr = row.description.length >maxLength ? row.description.substring(0, maxLength) + "..." : row.description;
                concatJustification.push(`${index +1}. ${truncatedStr}`)
            });
            const description = concatJustification.join('\n');
            const items = updatedRows.length;
            
            try {
                setConfirmationDialog({
                    open: true,
                    title: intl.formatMessage({ id: 'comp_leave.submitting' }),
                    uploadingMessage: true,
                    error: false
                });

                await submitRequest(updatedRows, totalHours, 'Request', description, items);
                setOpen(true);
                setError(false);

                setConfirmationDialog({
                    open: false,
                    title: intl.formatMessage({ id: 'comp_leave.submitting' }),
                    uploadingMessage: true,
                    error: false
                });

                setTimeout(function () {
                    setOpen(false);
                    history.push('/myCompleaveReqs');
                }, 3000);
            } catch (e) {
                setOpen(true);
                setError(true);
                setErrorMessage(
                    intl.formatMessage({ id: 'error.general_message' })
                );
                setConfirmationDialog({
                    open: false,
                    title: intl.formatMessage({ id: 'comp_leave.submitting' }),
                    uploadingMessage: true,
                    error: false
                });
                setTimeout(function () {
                    setOpen(false);
                    window.location.reload();
                }, 5000);
            }
        }
    };

    const checkIsDuplicateWithAppliedCompLeaveReqItems = (rows) => {
        return rows.some(row => {
            const newStart = moment(row.from, 'YYYY-MM-DD HH:mm');
            const newEnd = moment(row.to, 'YYYY-MM-DD HH:mm');
    
            return appliedCompLeaveReqItems.some(appliedRow => {
                const appliedStart = moment(appliedRow.from, 'YYYY-MM-DD HH:mm');
                const appliedEnd = moment(appliedRow.to, 'YYYY-MM-DD HH:mm');
    
                // Check duplicate
                return newStart.isBefore(appliedEnd) && newEnd.isAfter(appliedStart);
            });
        });
    };

    // Check is valid comp leave times
    const validateCompLeaveTimes = (rows) => {
        return rows.every((row) => {
            const from = moment(row.from);
            const to = moment(row.to);
            const workStart = moment('09:00', 'HH:mm');
            const workEnd = moment('18:00', 'HH:mm');
    
            const isNonWorkingTime = (type, time) => {
                //start > after woking hour
                if(type == 'start'){
                    return time.isSameOrAfter(workEnd) || time.isSameOrBefore(workStart);
                }else if(type == 'end'){
                    return time.isSameOrAfter(workEnd) || time.isSameOrBefore(workStart);
                }
            };
    
            const isNonWorkingDay = (day) => {
                return day.isoWeekday() >= 6 || 
                unformattedHoliday.includes(day.format('YYYY-MM-DD')) || 
                recentApprovedLeaveDates.includes(day.format('YYYY-MM-DD'));
            }
    
            const startTime = getTime(moment(from));
            const endTime = getTime(moment(to));
            
            if (isNonWorkingDay(from) && isNonWorkingDay(to)) {
                return true;
            }else if(!from.isSame(to,'day')){
                //from != to
                const validStart = isNonWorkingDay(from) || startTime.isSameOrAfter(workEnd);
                const validEnd = isNonWorkingDay(to) || endTime.isSameOrBefore(workStart)
                let rs = validStart && validEnd;
                return rs;
            }else if(isNonWorkingDay(from) && !isNonWorkingDay(to)){
                //check to is within working hour
                return isNonWorkingTime('end', endTime);
            } else if(!isNonWorkingDay(from) && isNonWorkingDay(to)){
                //check from is within working hour
                return isNonWorkingTime('start', startTime);
            } else if(!isNonWorkingDay(from) && !isNonWorkingDay(to)){
                //check both from & to is within working hour in same day
                if (startTime.isSameOrAfter(workEnd)) {
                    return endTime.isSameOrAfter(workEnd);
                } else if (startTime.isSameOrBefore(workStart)) {
                    return endTime.isSameOrBefore(workStart);
                }
                return false;
            } else {
                return false;
            }
        });
    };
   

    const handleUpload = async (files, rowIndex) => {
        if (files.length > 0) {
            setConfirmationDialog({
                open: true,
                title: intl.formatMessage({ id: 'new_application.dropzone_file_uploading' }),
                uploadingMessage: true,
                error: false
            });
    
            const promises = files.map(file => sendRequest(file));

            try {
                const responses = await Promise.all(promises);
                const attachments = responses.map(response => response.data.info);

                setRows(rows.map((row, index) => {
                    if (index === rowIndex) {
                        return {
                            ...row,
                            attachment: [...row.attachment, ...attachments]
                        };
                    }
                    return row;
                }));
            } catch (error) {
                setConfirmationDialog({
                    open: true,
                    title: intl.formatMessage({ id: 'new_application.dropzone_fail_upload' }),
                    uploadingMessage: true,
                    error: true
                });
            }
        }
    }

    const sendRequest = (file) => {
        let filename = file.name;
        if (isAlreadyUpload(file.name)) {
            const filenameToArray = file.name.split('.');
            const main = filenameToArray.slice(0, filenameToArray.length - 1).join(".");
            const extension = filenameToArray[filenameToArray.length - 1];
            const timestamp = moment().format('YYYY_MM_DD_hh_mm_ss');
            filename = `${main}(${timestamp}).${extension}`;
        }
    
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("attachment", file, filename);
    
            customAxios.post('/comp_leave_attachment', formData)
                .then(res => {
                    resolve(res);
                    setConfirmationDialog({
                        open: false,
                        title: intl.formatMessage({ id: 'new_application.dropzone_file_uploading' }),
                        uploadingMessage: true,
                        error: false
                    });
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    const isAlreadyUpload = (filename) => {
        return rows.some(row => 
            row.attachment.some(item => item.filename === filename)
        );
    };

    const handleAttachmentClick = url => {
        window.open(url, "_blank");
    };

    const handleAttachmentDelete = (rowIndex, file_id) => {
        setConfirmationDialog({
            open: true,
            title: intl.formatMessage({ id: 'new_application.delete_attachment_warning_title' }),
            msg: intl.formatMessage({ id: 'new_application.delete_attachment_warning_msg' }),
            target: {
                rowIndex: rowIndex,
                file_id: file_id,
            },
            uploadingMessage: false,
            error: false
        });
    }

    const handleConfirmationCancel = (event, reason) => {
        if (reason !== 'backdropClick') {
            setConfirmationDialog({
                open: false,
                msg: '',
                title: '',
                uploadingMessage: false,
                error: false
            });
        }
    }

    const handleConfirmationConfirm = () => {
        const { rowIndex, file_id } = confirmationDialog.target;
    
        customAxios.delete('/comp_leave_attachment/' + file_id)
            .then(res => {
                setRows(rows.map((row, index) => {
                    if (index === rowIndex) {
                        const filteredAttachments = row.attachment.filter((item) => item.file_id !== file_id);
                        
                        return {
                            ...row,
                            attachment: filteredAttachments
                        };
                    }
                    return row;
                }));
    
                setConfirmationDialog({
                    open: false,
                    msg: '',
                    title: '',
                    uploadingMessage: false,
                    error: false
                });
    
            }).catch(error => {
                console.error("Failed to delete attachment:", error);
                setConfirmationDialog({
                    open: true,
                    title: 'Error',
                    msg: 'Failed to delete attachment',
                    uploadingMessage: false,
                    error: true
                });
            });
    }

    const options = {
        customHeadRender: () => null,
        onRowsDelete: (rowsDeleted) => {
            handleRemoveRow(rowsDeleted.data[0].dataIndex);
        },
        selectableRows: 'none',
        pagination: true,
        page: page,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: isSubmitMode ? [5] : [10],
        onChangePage: handleChangePage,
        onChangeRowsPerPage: handleChangeRowsPerPage,
        search: false,
        filter: isSubmitMode ? false : true,
        display: false,
        download: false,
        print: false,
        viewColumns: isSubmitMode ? false : true,
        responsive: 'simple',
        customTableBodyFooterRender: (opts) => {
            return isTabletDevice || isDesktop || !isMobile ? (
                <TableFooter>
                    <TableRow>
                        {opts.columns.map((col, index) => {
                            return (
                                <TableCell
                                    key={index}
                                    className={classes.footerCell}
                                >
                                    {col.name === 'attachment' ? (
                                        <div>
                                            <FormattedMessage id='comp_leave.total_hours' />
                                            : {isSubmitMode ? totalHours : (application?.[0]?.hours || application?.hours)}
                                        </div>
                                    ) : null}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                </TableFooter>
            ) : (
                <TableFooter>
                    <TableRow>
                        <TableCell
                            className={classes.footerCell}
                        >
                            <div>
                                <FormattedMessage id='comp_leave.total_hours' />
                                : {isSubmitMode ? totalHours : (application?.[0]?.hours || application?.hours)}
                            </div>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            );
        },
    };

    const columns = setColumns(
        rows,
        handleInputChange,
        handleRemoveRow,
        calculateHours,
        errorMessages,
        mode,
        disabled,
        handleUpload,
        handleAttachmentClick,
        showRemoveFile,
        handleAttachmentDelete,
        handleCheckboxChange
    );

    return (
        <MuiThemeProvider theme={getMuiTheme()}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Typography
                        component='h1'
                        variant='h5'
                        align='left'
                        style={{ fontWeight: 600 }}
                    >
                        {formTitle}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.submitButtonDiv}>
                        {resubmitButton &&
                            <Button
                                style={{
                                    width: 110,
                                    backgroundColor: 'green',
                                    color: '#FFF',
                                }}
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => handleResubmit()}
                            >
                                {intl.formatMessage({
                                    id: 'comp_leave.re_submit',
                                })}
                            </Button>
                        }
                    </div>
                    {approveButton && (
                        <div className={classes.submitButtonDiv}>
                            <Hidden smDown>
                                <Button
                                    variant='contained'
                                    style={{
                                        width: 110,
                                        backgroundColor: 'green',
                                        color: '#FFF',
                                    }}
                                    size='small'
                                    startIcon={<CheckCircleIcon />}
                                    onClick={() => handleConfirmOpen('approve')}
                                >
                                    {intl.formatMessage({
                                        id: 'comp_leave.approve',
                                    })}
                                </Button>
                                <Button
                                    style={{ marginLeft: 10, width: 110 }}
                                    variant='contained'
                                    color='secondary'
                                    size='small'
                                    startIcon={<CancelIcon />}
                                    onClick={() => handleConfirmOpen('reject')}
                                >
                                    {intl.formatMessage({
                                        id: 'comp_leave.reject',
                                    })}
                                </Button>
                            </Hidden>

                            <Hidden mdUp>
                                <Button
                                    variant='contained'
                                    style={{
                                        backgroundColor: 'green',
                                        color: '#FFF',
                                        minWidth: 60,
                                    }}
                                    size='small'
                                    onClick={() => handleConfirmOpen('approve')}
                                >
                                    <CheckCircleIcon />
                                </Button>
                                <Button
                                    style={{ marginLeft: 10, minWidth: 60 }}
                                    variant='contained'
                                    color='secondary'
                                    size='small'
                                    onClick={() => handleConfirmOpen('reject')}
                                >
                                    <CancelIcon />
                                </Button>
                            </Hidden>
                        </div>
                    )}

                    <div className={classes.submitButtonDiv}>
                        {addButton && (
                            <Button
                                variant='contained'
                                onClick={handleAddRow}
                                style={{
                                    backgroundColor: '#232F3F',
                                    color: '#FFF',
                                }}
                            >
                                <AddIcon />
                            </Button>
                        )}
                        
                        {withDrawnButton && (
                            <Button
                                style={{ width: 110 }}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => handleConfirmOpen('withdraw')}
                            >
                                {intl.formatMessage({ id: 'comp_leave.withdraw' })}
                            </Button>
                        )}

                        {cancelButton && (
                            <Button
                                style={{ width: 110, marginTop: approveButton ? 8 : undefined }}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => handleConfirmOpen('cancel')}
                            >
                                {intl.formatMessage({ id: 'comp_leave.cancel' })}
                            </Button>
                        )}
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <>
                        <MUIDataTable
                            title={
                                isMobile && mode == window.global.submitMode ? (
                                    <div className={classes.spaceBetween}>
                                        <div style={{fontSize: 14.7}}>
                                            {intl.formatMessage({
                                                id: 'comp_leave.extra_duty_report_form',
                                            })}
                                        </div>
                                        <div style={{fontSize: 12}}>Page {page + 1}</div>
                                    </div>
                                ) : (
                                    <div style={{fontSize: 14.7}}>
                                        {intl.formatMessage({
                                            id: 'comp_leave.extra_duty_report_form',
                                        })}
                                    </div>
                                )
                            }
                            data={data}
                            columns={columns}
                            hideFooterPagination
                            hideFooterSelectedRowCount
                            hideFooter
                            isRowSelectable={false}
                            options={options}
                        />
                        {submitButton && (
                            <Button
                                variant='contained'
                                onClick={handleSubmit}
                                style={{
                                    float: 'right',
                                    marginTop: '16px',
                                    backgroundColor: '#232F3F',
                                    color: '#FFF',
                                }}
                            >
                                <FormattedMessage id='new_application.submit' />
                            </Button>
                        )}

                        {approveOpen && (
                            <ConfirmBox
                                approveMode={approveMode}
                                leaveMode={window.global.compLeaveRequest}
                                approveId={approveId}
                                handleClose={handleConfirmClose}
                                open={approveOpen}
                                isApprove={action}
                                editUpdatedAt={application.updated_at}
                                tabIndex={tabIndex}
                            />
                        )}

                        {withDrawOpen && (
                            <WithDrawConfirm
                                editApplicationId={application?.[0]?.id || application?.id}
                                open={withDrawOpen}
                                handleClose={handleConfirmClose}
                                action={action}
                                backToTable={backToTable} 
                                page={actionPage}
                                tabIndex={tabIndex}
                                isNewCompLeave={true}
                            />
                        )}

                        {alertCancelOpen && (
                            <CancelAlertBox
                                open={alertCancelOpen}
                                handleClose={handleConfirmClose}
                                compLeaveRecord={compLeaveRecord}
                            />
                        )}

                        <Modal
                            open={open}
                            className={classes.modal}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >
                            <Fade in={open}>
                                <Paper className={classes.afterSubmitPage}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {!isError ? (
                                                <Typography
                                                    className={classes.title}
                                                >
                                                    <FormattedMessage id='new_application.review_success_message' />
                                                </Typography>
                                            ) : (
                                                <Typography
                                                    className={classes.title}
                                                >
                                                    {errorMessage}
                                                </Typography>
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            {!isError ? (
                                                <CheckCircleIcon
                                                    style={{
                                                        fontSize: '100px',
                                                        color: 'green',
                                                    }}
                                                />
                                            ) : (
                                                <CancelIcon
                                                    color='secondary'
                                                    style={{ fontSize: '100px' }}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Fade>
                        </Modal>
                    </>
                </Grid>
            </Grid>
            <ConfirmationBox
                handleCancel={handleConfirmationCancel}
                handleConfirm={handleConfirmationConfirm}
                open={confirmationDialog.open}
                msg={confirmationDialog.msg}
                title={confirmationDialog.title}
                uploadingMessage={confirmationDialog.uploadingMessage}
                error={confirmationDialog.error}
            />
        </MuiThemeProvider>
    );
}
